import PropTypes from "prop-types";

export default PropTypes.shape({
  accountManagers: PropTypes.string,
  benefits: PropTypes.string,
  candidatesRejected: PropTypes.number,
  competencies: PropTypes.number,
  considerRelocation: PropTypes.bool.isRequired,
  contractDuration: PropTypes.string,
  customTerms: PropTypes.string,
  customTermsUrl: PropTypes.string,
  cvsRead: PropTypes.number,
  degreeRequired: PropTypes.bool.isRequired,
  description: PropTypes.string.isRequired,
  employerAverageTimeToRespond: PropTypes.string,
  feedbackTimescale: PropTypes.string.isRequired,
  firstStageInterview: PropTypes.number,
  hasCustomTerms: PropTypes.bool,
  interviewStages: PropTypes.string,
  jobType: PropTypes.string.isRequired,
  keySkills: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  numberOfPositions: PropTypes.number.isRequired,
  offerMade: PropTypes.string,
  numberOfOffersMade: PropTypes.number,
  phoneInterviews: PropTypes.number,
  placementFeePercent: PropTypes.number,
  recruiterGuidance: PropTypes.string,
  salary: PropTypes.string,
  secondStageInterview: PropTypes.number,
  sector: PropTypes.string,
  submittedCvs: PropTypes.number,
  visaSponsorship: PropTypes.bool.isRequired,
});
